// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2vaSU","label":"Radio_label__1VFEV","checkMark":"Radio_checkMark__3Rhg7","disabled":"Radio_disabled__3roTF"};